export default __webpack_public_path__ + "static/media/02AW1-2AUG66.cc79b90a.jpg";